module.exports = __webpack_public_path__ + "500c5bd05a728c7d52e61280be033852.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/karty.jpg
// module id = 1239
// module chunks = 0